import { useMemo } from "react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { getFlexibleTicketTotalUpgradePrice } from "../../../utils/flexibility.js";
import useFormatPrice from "../../../../hooks/useFormatPrice.js";
export default function useFlexTicketItemController(props) {
    const { showLoadingPrice, flexibleTicket, hasGeniusDeal, renderTextOnly } = props;
    const i18n = useI18n();
    const { formatPrice } = useFormatPrice();
    const flexibleTicketTotalPrice = getFlexibleTicketTotalUpgradePrice(flexibleTicket);
    const flexibleTicketUpgradePrice = formatPrice(flexibleTicketTotalPrice.total);
    const flexibleTicketPriceStrikethrough = useMemo(() => flexibleTicketTotalPrice.showPriceStrikethrough && flexibleTicketTotalPrice.totalWithoutDiscount
        ? formatPrice(flexibleTicketTotalPrice.totalWithoutDiscount)
        : undefined, [flexibleTicketTotalPrice.showPriceStrikethrough, flexibleTicketTotalPrice.totalWithoutDiscount, formatPrice]);
    const flexibleTicketPriceStrikethroughA11yText = useMemo(() => !!flexibleTicketPriceStrikethrough
        ? i18n.trans(t("a11y_flights_fd_genius_flex_ticket_discounted_price_hint", {
            variables: {
                price_diff: flexibleTicketUpgradePrice,
                price_diff_without_discount: flexibleTicketPriceStrikethrough
            }
        }))
        : undefined, [flexibleTicketPriceStrikethrough, flexibleTicketUpgradePrice, i18n]);
    const priceCopy = t("flights_apex_fd_extras_flex_ticket_price", {
        variables: { price_diff: flexibleTicketUpgradePrice }
    });
    return {
        priceCopy,
        hasGeniusDeal,
        renderTextOnly,
        flexibleTicket,
        showLoadingPrice,
        flexibleTicketPriceStrikethrough,
        flexibleTicketPriceStrikethroughA11yText
    };
}
